import { reportError } from "@/lib/observability/reportError";
import { DEFAULT_ERROR_MESSAGE } from "@/lib/request/extractApiErrorMessage";

const USER_FACING_STRIPE_ERROR_TYPES = new Set([
  "card_error",
  "validation_error",
]);

interface StripeLikeError {
  type: string;
  message?: string | null;
}

export function resolveStripeErrorMessage(
  error: StripeLikeError | null | undefined,
  source: string,
) {
  const isUserFacing =
    !!error &&
    USER_FACING_STRIPE_ERROR_TYPES.has(error.type) &&
    !!error.message;
  if (!isUserFacing) {
    reportError(error ?? new Error("Stripe card setup did not complete"), {
      source,
    });
  }
  return isUserFacing ? error.message! : DEFAULT_ERROR_MESSAGE;
}
